import axios from "axios";
import { GET_ALL_COMMON } from "./types";
const keys = require("../config/keys");

export const getCommonAll = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/Common/GetCommonAll"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: GET_ALL_COMMON, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getCommonAll.js